import { useTheme } from "@emotion/react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import "./SelectRoleDialog.css";

import { impersonate } from "apis/controllers/admin";
import { useSnackbar } from "notistack";
import { useQueryClient } from "react-query";
import { login } from "store/authReducer";
import { storeMenu } from "store/menuReducer";

const RoleCard = ({ data, handleSelectRole, isSelected }) => {
  const { t } = useTranslation();

  return (
    <div
      disabled={isSelected}
      className={`role-card-container ${isSelected ? "selected" : ""}`}
      onClick={isSelected ? () => { } : () => handleSelectRole()}
    >
      <div className="role-card-title">
        {isSelected ? `${data?.roleName} (Τωρινή Επιλογή)` : data?.roleName}
      </div>
      <div className="role-card-detail">{data?.functionName}</div>
      <div className="role-card-status">{data?.orgName}</div>
    </div>
  );
};

const SelectRoleDialog = (props) => {
  const { open, onClose, roles } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const [disabledButtons, setDisabledButtons] = useState(false);
  const navigate = useNavigate();
  const form = useFormContext();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const handleSelectRole = async (item) => {
    const res = await impersonate({
      username: form?.watch("username"),
      urpfId: item?.value,
    });
    if (res?.token) {
      dispatch(storeMenu(res?.menu));
      dispatch(
        login({
          token: res?.token,
          refreshToken: res?.refreshToken,
          user: res?.user,
          seasonId: res?.season
        })
      );
      enqueueSnackbar(`Επιτυχής σύνδεση`, {
        variant: "success",
      });
      navigate("/home");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="h3" sx={{ flexGrow: 1 }}>
          ΕΠΙΛΟΓΗ ΡΟΛΟΥ
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: "#fefefe" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          spacing={4}
          sx={{ mb: 0 }}
        >
          <DialogContentText>
            <Box
              sx={{
                p: 1,
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
              }}
            >
              Παρακαλώ επιλέξτε τον ρόλο με τον οποίο θέλετε να συνδεθείτε.
            </Box>
          </DialogContentText>
        </Stack>
        <div className="role-card-grid">
          {roles?.map((item, index) => (
            <RoleCard
              key={index}
              data={item}
              isSelected={item?.selected}
              handleSelectRole={() => handleSelectRole(item)}
            />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SelectRoleDialog;
